<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="岗位名称">
      <el-input v-model="queryParam.name" placeholder="岗位名称" />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="岗位状态">
        <el-option label="正常" :value="1"/>
        <el-option label="停用" :value="2"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListPosition">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doPositionAdd()"
          v-hasPermission="['system:position:add']"
          >添加岗位</el-button>
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
  <el-table
    :data="tableData"
    v-loading="loadingData"
    class="mainTable"
    row-key="positionid"
  >
    <el-table-column label="岗位名称" prop="name" width="200" />
    <el-table-column label="描述" prop="desc"/>
    <el-table-column label="日期" prop="created">
      <template #default="scope">
        <span
          v-text="util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')"
        ></span>
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="status">
      <template #default="scope">
        <el-tag
          round
          :type="scope.row.status === 1 ? 'success' : 'danger'"
          disable-transitions
          ><span v-text="util.showCommonStatus(scope.row.status)"></span>
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" fixed="right" width="160">
      <template #default="scope">
        <el-link
          type="primary"
          size="small"
          @click="(dialog = true), doPositionEdit(scope.$index, scope.row)"
          v-hasPermission="['system:position:edit']"
          >编辑</el-link
        >

        <el-popconfirm
          confirm-button-type="danger"
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon-color="#626AEF"
          title="您确定要删除吗？"
          @confirm="doPositionDelete(scope.$index, scope.row)"
        >
          <template #reference>
            <el-link
              size="small"
              type="danger"
              v-hasPermission="['system:position:delete']"
              >删除</el-link
            >
          </template>
        </el-popconfirm>
      </template>
    </el-table-column>
  </el-table>
  </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"><div>
        <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
      </div></el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="true"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="45%"
    @close="doPositionClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="positionFormRef"
        :model="positionForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="positionForm.name"
            placeholder="请输入岗位名称"
          />
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input
            v-model.trim="positionForm.desc"
            type="textarea"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="positionForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doPositionClose">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doPositionSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
    
  <script setup>
import { ref, onMounted } from "vue";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listPosition, savePosition, deletePosition } from "@/api/position";

import util from "@/util/tool.js";

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const positionFormRef = ref();

const total = ref(0);
const pageSize = ref(15); //每页显示条数


let title = ref("添加岗位");

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: '',
  status: '',
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: '',
    status: '',
  };
  getListPosition();
};

const positionForm = ref({
  positionid: null,
  name: '',
  desc: '',
  status: 1,
});

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  getListPosition();
});

const doPositionAdd = () => {
  title.value = "新增岗位";
  resetForm();
};

const doPositionEdit = (index, obj) => {
  title.value = "编辑岗位";
  // positionForm.value = obj;//直接赋值会出问题

  positionForm.value = {
    positionid: obj.positionid,
    name: obj.name,
    desc: obj.desc,
    status: obj.status
  };
};
const doPositionDelete = (index, obj) => {
  // console.log(obj.positionid, obj.parentid, obj.name);
  deletePosition(obj).then((res) => {
    // console.log(res);
    if (res.data.code === 1) {
      getListPosition();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

const doPositionClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  positionFormRef.value.resetFields()
};

const resetForm = () => {
  positionForm.value = {
    positionid: null,
    name: '',
    desc: '',
    status: 1,
  };
};

const doPositionSave = () => {
  positionFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    savePosition(positionForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListPosition();
          doPositionClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//关闭用户表单弹出框
// const doDrawerClose = (done) => {
//   if (loading.value) {
//     return;
//   }
//   ElMessageBox.confirm("您确定要提交表单数据吗？", {
//     distinguishCancelAndClose: true,
//     confirmButtonText: "确定提交",
//     cancelButtonText: "取消",
//   })
//     .then(() => {
//       loading.value = true;
//       timer = setTimeout(() => {
//         done();
//         // 动画关闭需要一定的时间
//         setTimeout(() => {
//           loading.value = false;
//         }, 400);
//       }, 1000);
//     })
//     .catch(() => {
//       // catch error
//     });
// };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListPosition();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListPosition();
};

//岗位表API
const getListPosition = () => {
  listPosition(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 30,
      message: "名称长度2到30",
      trigger: "blur",
    },
  ],
  desc: [
    {
      message: "请输入岗位描述",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "岗位描述长度2到200",
      trigger: "blur",
    },
  ],
});
</script>